/* eslint-disable react/require-default-props */

import React from 'react';
import { svgs, IconType } from './icons';
import './index.scss';

export default function Icon(
  {
    iconType,
    color = '#000', // tema: fixo (sem cor explícita, o `:where` de assets/theme/_base.scss segue o texto)
    size = 'regular',
    id = undefined,
    className = '',
    onClick = undefined,
  }: {
    iconType: IconType;
    color?: string;
    size?: 'regular' | 'large' | 'small';
    id?: string | undefined;
    className?: string;
    onClick?: (() => void) | undefined;
  },
) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      className={`icon-style ${size} ${className}`}
      onClick={onClick}
    >
      {svgs[iconType]}
    </svg>
  );
}
